<template><menu-form :id="$route.params.id" /></template>
<script>
import MenuForm from './MenuForm.vue'

export default { components: { MenuForm } }
</script>
